import React from 'react'
import { Button } from 'foundations-library/components'
import { createStyles, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme =>
    createStyles({
        submitButton: {
            width: '100%',
            border: 0,
            cursor: 'pointer'
        }
    })
)

interface SubmitButtonProps {
    children: React.ReactNode;
    disabled?: boolean;
}

/**
 * Large green submit button used to proceed to the next step / submit the order.
 */
const SubmitButton = ({ children, disabled }: SubmitButtonProps) : JSX.Element => {
    const classes = useStyles()

    return (
        <Button type="submit" disabled={disabled} data-testid="submit-button" className={classes.submitButton} icon={'go'} size={'large'}>{children}</Button>
    )
}

export default SubmitButton
